import { env } from '@lcsc-ui/utils/baseUrl';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

let listServe = '/lcsc-list';
if (env === 'local') {
  listServe = 'https://devlist.szlcsc.com';
}

const ListApi = {
  brandPageCatalog: `${listServe}/brand/page/catalog`,
  selectionPlanRelatedProducts: `${listServe}/component/selection/plan/related_products`,
  icDetail: `${listServe}/ic/detail`,
  icRecommend: `${listServe}/ic/recommend`,
};

export default ListApi;

export function getHotRecommend(params) {
  return sendAxios({
    method: 'get',
    url: '/hot/recommend/20',
    baseURL: Domains.lcscListUrl,
    params,
  });
}
